const accountPopup = () => {
  const Classes = {
    body: 'panel-open-popup',
    sidebar: 'sidebar-popup',
  };

  const Selector = {
    icon: document.querySelector('.my-account-menu-overlay'),
    closeBtn: document.querySelector('.closebtn-my-account'),
  };

  const openpopup = () => {
    document.body.classList.toggle(Classes.body);
  };

  [Selector.icon, Selector.closeBtn]?.forEach((element: HTMLElement) => {
    element?.addEventListener('click', (event: Event) => {
      event.stopPropagation();

      openpopup();
    });
  });
};

export default accountPopup;
